import { autoinject, transient } from "aurelia-dependency-injection";
import { RightShipInspectionModel, RightShipInspectionType } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import { Reflection } from "../../../../../../utilities/reflection";
import { computedFrom } from "aurelia-binding";

@autoinject
@transient()
export class ShipManagerDetailsTab {

    item: RightShipInspectionModel;
    technicalManagerCountryCode: string;
    additionalEmailsToNotify: { email: string }[] = [];
    activate(item: RightShipInspectionModel) {
        this.item = item;
    }

    @computedFrom(Reflection.getPropertyPath<ShipManagerDetailsTab>(z => z.item),
    Reflection.getPropertyPath<ShipManagerDetailsTab>(z => z.item.rightShipInspectionTypeId))
    get isCargill() {
        return this.item && this.item.rightShipInspectionTypeId == RightShipInspectionType.CargillSurvey;
    }

    removeEmail(index) {
        this.setAdditionalEmailsToNotifyString();
        this.item.additionalEmailsToNotify = this.removeEmailFromList(index, this.additionalEmailsToNotify);
        this.additionalEmailsToNotify = this.getListOfEmails(this.item.additionalEmailsToNotify);
    }

    addEmail() {
        this.setAdditionalEmailsToNotifyString();
        if (!this.item.additionalEmailsToNotify && this.item.additionalEmailsToNotify != "")
            this.item.additionalEmailsToNotify = "";
        else
            this.item.additionalEmailsToNotify += ";";
        this.additionalEmailsToNotify = this.getListOfEmails(this.item.additionalEmailsToNotify);
    }

    removeEmailFromList(index: any, emails: any) {
        let emailsAsString = "";

        for (let i = 0; i < emails.length; i++) {
            if (index != i) {
                if (i > 0)
                    emailsAsString += ";";

                emailsAsString += emails[i].email;
            }
        }

        return emailsAsString;
    }

    getListOfEmails(emails: string) {
        let listOfEmails = [];

        if (emails != null) {
            listOfEmails = emails.split(";").map(x => {
                return { email: x.trim() };
            });
        }

        return listOfEmails;
    }

    setAdditionalEmailsToNotifyString() {
        if (this.item) {
            if (this.additionalEmailsToNotify.length > 0) {
                this.item.additionalEmailsToNotify = this.additionalEmailsToNotify.map(x => x.email).join(";");
            } else {
                this.item.additionalEmailsToNotify = null;
            }
        }
    }
}